<script>
import sizeMixin from "./sizeMixin";
import DashTip from "./DashTip";
import StatusMark from "./StatusMark";
import { fmtNum } from "@/data/dashboardModel";

// Medidor "meta como techo" (accidentalidad): relleno = valor del año, marca = meta.
// Dentro de la meta = teal; excedida = rojo con icono + texto; sin meta = gris + instrucción.
export default {
  name: "Meter",
  components: { DashTip, StatusMark },
  mixins: [sizeMixin],
  props: {
    title: { type: String, required: true }, // "Frecuencia"
    unit: { type: String, required: true }, // "accidentes" | "días"
    unitOne: { type: String, default: "" }, // singular
    value: { type: Number, required: true },
    goal: { type: Number, default: null },
    index: { type: String, default: "" }, // "Índice de frecuencia 0,09"
    ready: { type: Boolean, default: false },
    to: { type: [String, Object], default: "/forms/estandares" },
  },
  data() {
    return { on: false };
  },
  computed: {
    hasGoal() {
      return this.goal !== null;
    },
    over() {
      return this.hasGoal && this.value > this.goal;
    },
    domain() {
      return Math.max(this.value, this.goal || 0, 1) * 1.25;
    },
    fillPct() {
      return this.ready ? (this.value / this.domain) * 100 : 0;
    },
    goalPct() {
      return this.hasGoal ? (this.goal / this.domain) * 100 : 0;
    },
    unitFor() {
      return (n) => (n === 1 && this.unitOne ? this.unitOne : this.unit);
    },
    tipX() {
      const pct = this.hasGoal ? this.goalPct : (this.value / this.domain) * 100;
      return (pct / 100) * (this.width || 280);
    },
    status() {
      if (!this.hasGoal) return null;
      const diff = Math.abs(this.value - this.goal);
      if (this.over) {
        return { key: "critical", label: `Excede la meta en ${fmtNum(diff)} ${this.unitFor(diff)}` };
      }
      return { key: "good", label: this.value === this.goal ? "En el límite de la meta" : "Dentro de la meta" };
    },
    reading() {
      const base = `${this.title}: ${fmtNum(this.value)} ${this.unitFor(this.value)}`;
      if (!this.hasGoal) return `${base}. Sin meta definida.`;
      return `${base}; meta ${fmtNum(this.goal)}. ${this.status.label}.`;
    },
  },
  methods: { fmtNum },
};
</script>

<template>
  <div class="dsh-meter" :class="{ 'is-over': over, 'is-nogoal': !hasGoal }">
    <div class="dsh-meter__head">
      <span class="dsh-meter__title">{{ title }}</span>
      <span class="dsh-meter__value">{{ fmtNum(value) }} <small>{{ unitFor(value) }}</small></span>
    </div>
    <div
      ref="measure"
      class="dsh-meter__plot"
      role="img"
      tabindex="0"
      :aria-label="reading"
      @mouseenter="on = true"
      @mouseleave="on = false"
      @focus="on = true"
      @blur="on = false"
    >
      <span class="dsh-meter__track">
        <span class="dsh-meter__fill" :style="{ width: fillPct + '%' }"></span>
      </span>
      <span v-if="hasGoal" class="dsh-meter__goal" :style="{ left: goalPct + '%' }"></span>
      <DashTip :show="on" :x="tipX" :y="0" side="top">
        <div class="dsh-tip__head">{{ title }}</div>
        <div class="dsh-tip__value">{{ fmtNum(value) }} {{ unitFor(value) }}</div>
        <div class="dsh-tip__row">{{ hasGoal ? "Meta anual: " + fmtNum(goal) + " " + unitFor(goal) : "Sin meta definida" }}</div>
        <div v-if="index" class="dsh-tip__row">{{ index }}</div>
      </DashTip>
    </div>
    <div class="dsh-meter__foot">
      <StatusMark v-if="status" :status="status" />
      <span v-else class="dsh-meter__nogoal">
        Sin meta definida.
        <router-link :to="to">Defínela en 3.3.1 / 3.3.2</router-link>
      </span>
      <span v-if="hasGoal" class="dsh-meter__goal-text">Meta: {{ fmtNum(goal) }}</span>
    </div>
    <p v-if="index" class="dsh-meter__index">{{ index }}</p>
  </div>
</template>
